import React, {
  Dispatch,
  ReactNode,
  SetStateAction,
  useContext,
  useMemo,
  useState,
} from "react";

interface IProps {
  children: ReactNode;
}

interface IInfoPayment {
  pregeneratePolicyId?: string;
  checkout?: {
    sessionTransaction: string;
    plan?: {
      checkoutUrl: string;
    };
    [key: string]: any;
  };
}

type IContext = {
  step: number;
  usePaymentGateway: boolean;
  infoPayment: IInfoPayment | null;
  formData: any;
  setStep: Dispatch<SetStateAction<number>>;
  setUsePaymentGateway: Dispatch<SetStateAction<boolean>>;
  setInfoPayment: Dispatch<SetStateAction<IInfoPayment | null>>;
  setFormData: Dispatch<SetStateAction<any>>;
  handleInitialState: () => void;
  resetFormCallback: (() => void) | null;
  setResetFormCallback: Dispatch<SetStateAction<(() => void) | null>>;
};

export const CreateSimplyAcincoContext = React.createContext<IContext>(
  {} as IContext,
);

export const useCreateSimplyAcincoContext = () =>
  useContext<IContext>(CreateSimplyAcincoContext);

const CreateSimplyAcincoProvider = ({ children }: IProps) => {
  const [step, setStep] = useState<number>(1);
  const [usePaymentGateway, setUsePaymentGateway] = useState<boolean>(false);
  const [infoPayment, setInfoPayment] = useState<IInfoPayment | null>(null);
  const [formData, setFormData] = useState<any>(null);
  const [resetFormCallback, setResetFormCallback] = useState<
    (() => void) | null
  >(null);

  const handleInitialState = () => {
    setStep(1);
    setUsePaymentGateway(false);
    setInfoPayment(null);
    setFormData(null);
    // Resetear formulario si el callback existe
    if (resetFormCallback) {
      resetFormCallback();
    }
  };

  const context: IContext = useMemo(
    () => ({
      step,
      usePaymentGateway,
      infoPayment,
      formData,
      setStep,
      setUsePaymentGateway,
      setInfoPayment,
      setFormData,
      handleInitialState,
      resetFormCallback,
      setResetFormCallback,
    }),
    [step, usePaymentGateway, infoPayment, formData, resetFormCallback],
  );

  return (
    <CreateSimplyAcincoContext.Provider value={context}>
      {children}
    </CreateSimplyAcincoContext.Provider>
  );
};

export default CreateSimplyAcincoProvider;
